import script from "./SidebarContent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarContent.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarContent.vue?vue&type=style&index=0&id=fe269346&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe269346"]])

export default __exports__